module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "site-header"
  }, [_c('Navbar'), _vm._v(" "), _c('div', {
    staticClass: "logo-container"
  }, [_c('router-link', {
    staticClass: "no-style",
    attrs: {
      "to": '/',
      "exact": ""
    }
  }, [_c('PictureLoader', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo.png",
      "lazy": "false"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-07790ed8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 95
// module chunks = 4